import { useState } from "react";
import { toast } from "sonner";
import { subscribe, useConfig } from "@/lib/api";
import { useCart } from "@/lib/cart";
import { useI18n } from "@/lib/i18n";
import { Reveal, SplitText, Magnetic } from "@/components/fx/Motion";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const { setDiscount } = useCart();
  const { t } = useI18n();
  const { data: cfg } = useConfig();
  const pct = cfg?.discount_percent || 10;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await subscribe(email, "footer");
      setDiscount(r.discount_code);
      localStorage.setItem("ajs_popup_done", "1");
      toast.success(t("newsletter_success", { code: r.discount_code }));
      setEmail("");
    } catch {
      toast.error(t("invalid_email"));
    }
    setBusy(false);
  };

  return (
    <section data-testid="newsletter-section" className="relative grain border-b border-white/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-20 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <p className="eyebrow mb-4">{t("newsletter_eyebrow")}</p>
          <h2 className="font-display text-3xl lg:text-5xl leading-tight">
            <SplitText text={t("newsletter_title_1")} /><br />
            <em className="text-gold"><SplitText text={t("newsletter_title_2", { pct })} delay={0.2} /></em> <SplitText text={t("newsletter_title_3")} delay={0.35} />
          </h2>
        </div>
        <Reveal delay={0.2}>
          <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3">
            <input data-testid="newsletter-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder={t("email_placeholder")} className="sm:flex-1 h-14 shrink-0 bg-transparent border border-white/15 px-5 text-sm focus:outline-none focus:border-[#c9a55c] transition-colors" />
            <Magnetic className="w-full sm:w-auto"><button data-testid="newsletter-submit-button" disabled={busy} className="btn-gold h-14 px-8 w-full">{busy ? t("joining") : t("subscribe")}</button></Magnetic>
          </form>
        </Reveal>
      </div>
    </section>
  );
};
